module.exports = __webpack_public_path__ + "static/media/home-light.72115940.svg";